export default "__VITE_ASSET__BSb4W$5T__";